import { render, staticRenderFns } from "./GroupLayerElement.vue?vue&type=template&id=00bd3806&scoped=true"
import script from "./GroupLayerElement.vue?vue&type=script&lang=ts"
export * from "./GroupLayerElement.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./GroupLayerElement.vue?vue&type=style&index=0&id=00bd3806&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "00bd3806",
  null
  ,true
)

export default component.exports